// extracted by mini-css-extract-plugin
module.exports = {"container":"UserProfileViewBooksEmpty__container","text":"UserProfileViewBooksEmpty__text"};